import type { ILanguageResources, ITranslationModule } from '../../../interfaces';
import { interpolate } from '../../../global';

class Id {
  private constructor() {}
  public static readonly prefix = 'UI.scripts.fabricationJobs.FabricationJobDetailView.';
  public static readonly informationTab = `${Id.prefix}informationTab`;
  public static readonly jobItemsTab = `${Id.prefix}jobItemsTab`;
  public static readonly titleLabel = `${Id.prefix}titleLabel`;
  public static readonly descriptionLabel = `${Id.prefix}descriptionLabel`;
  public static readonly createdLabel = `${Id.prefix}createdLabel`;
  public static readonly modifiedLabel = `${Id.prefix}modifiedLabel`;
  public static readonly refreshButton = `${Id.prefix}refreshButton`;
  public static readonly loadingText = `${Id.prefix}loadingText`;
  public static readonly untitled = `${Id.prefix}untitled`;
  public static readonly stateDraft = `${Id.prefix}stateDraft`;
  public static readonly statePlanned = `${Id.prefix}statePlanned`;
  public static readonly stateAwaitingOrder = `${Id.prefix}stateAwaitingOrder`;
  public static readonly stateReadyForProduction = `${Id.prefix}stateReadyForProduction`;
  public static readonly stateInProduction = `${Id.prefix}stateInProduction`;
  public static readonly stateCompleted = `${Id.prefix}stateCompleted`;
  public static readonly jobTitleHeading = `${Id.prefix}jobTitleHeading`;
}

export class LangFabricationJobDetailView {
  private constructor() {}
  public static informationTab(): string {
    return interpolate(Id.informationTab);
  }
  public static jobItemsTab(): string {
    return interpolate(Id.jobItemsTab);
  }
  public static titleLabel(): string {
    return interpolate(Id.titleLabel);
  }
  public static descriptionLabel(): string {
    return interpolate(Id.descriptionLabel);
  }
  public static createdLabel(): string {
    return interpolate(Id.createdLabel);
  }
  public static modifiedLabel(): string {
    return interpolate(Id.modifiedLabel);
  }
  public static refreshButton(): string {
    return interpolate(Id.refreshButton);
  }
  public static loadingText(): string {
    return interpolate(Id.loadingText);
  }
  public static untitled(): string {
    return interpolate(Id.untitled);
  }
  public static stateDraft(): string {
    return interpolate(Id.stateDraft);
  }
  public static statePlanned(): string {
    return interpolate(Id.statePlanned);
  }
  public static stateAwaitingOrder(): string {
    return interpolate(Id.stateAwaitingOrder);
  }
  public static stateReadyForProduction(): string {
    return interpolate(Id.stateReadyForProduction);
  }
  public static stateInProduction(): string {
    return interpolate(Id.stateInProduction);
  }
  public static stateCompleted(): string {
    return interpolate(Id.stateCompleted);
  }
  public static jobTitleHeading(jobNumber: string, title: string): string {
    return interpolate(Id.jobTitleHeading, { jobNumber, title });
  }
}

export class FabricationJobDetailViewModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    register.add(Id.informationTab, 'Information', 'Tab caption for fabrication job information');
    register.add(Id.jobItemsTab, 'Job Items', 'Tab caption for fabrication job items');
    register.add(Id.titleLabel, 'Title', 'Form label for fabrication job title');
    register.add(Id.descriptionLabel, 'Description', 'Form label for fabrication job description');
    register.add(Id.createdLabel, 'Created', 'Form label for fabrication job creation date');
    register.add(Id.modifiedLabel, 'Modified', 'Form label for fabrication job last modified date');
    register.add(Id.refreshButton, 'Refresh', 'Button text to refresh fabrication job items');
    register.add(Id.loadingText, 'Loading...', 'Text shown while loading fabrication job data');
    register.add(Id.untitled, 'Untitled', 'Placeholder for untitled fabrication job');
    register.add(Id.stateDraft, 'Draft', 'Fabrication job state label for Draft');
    register.add(Id.statePlanned, 'Planned', 'Fabrication job state label for Planned');
    register.add(Id.stateAwaitingOrder, 'Awaiting Order', 'Fabrication job state label for Awaiting Order');
    register.add(Id.stateReadyForProduction, 'Ready for Production', 'Fabrication job state label for Ready for Production');
    register.add(Id.stateInProduction, 'In Production', 'Fabrication job state label for In Production');
    register.add(Id.stateCompleted, 'Completed', 'Fabrication job state label for Completed');
    register.add(Id.jobTitleHeading, 'Job #{{jobNumber}} {{title}}', 'Heading format for fabrication job detail view');
  }
}
